import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import {
  getPTZ, getResponseError, onlyNumbersOption, round,
} from '../../../utils/utils';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import notificationDecorator, {
  errorNotification,
  successNotification,
} from '../../Notifications/notificationDecorator';
import { setPTZ, updateCamera } from '../../Settings/actions';
import { createPosition, savePosition } from '../actions';
import { getZonesData } from '../reducer';

export default function CameraPositionFrom(props) {
  const {
    camera = null, position = null, editZone = false, editPosition = false, loadData = () => {},
  } = props;
  const intl = useIntl();
  const { formatMessage } = intl;
  const dispatch = useDispatch();
  const {
    positionByCameraList = [],
  } = useSelector(getZonesData);
  const defaultCameraValue = getPTZ(camera.position);
  const {
    register, getValues, watch, setValue,
  } = useForm({
    mode: 'onChange',
    defaultValues: position || defaultCameraValue,
  });

  const handleSave = () => {
    const values = getPTZ(getValues());
    if (values.pan === camera.pan && values.tilt === camera.tilt && values.zoom === camera.zoom) {
      return;
    }
    dispatch(setPTZ({ values, id: camera.id }))
      .then(() => {
        dispatch(updateCamera({ ...camera, ...values }));
      })
      .catch(response => errorNotification(formatMessage({ id: 'camera.save.ptz' }), getResponseError(response)));
  };

  const handleSavePosition = () => {
    const values = getValues();
    let action = createPosition({
      ...values, camera_id: camera.id, number: positionByCameraList.length + 1, active: true,
    });
    if (position && position.id) {
      action = savePosition({ id: position.id, data: values });
    }
    dispatch(action)
      .then(() => {
        loadData();
        successNotification(formatMessage({ id: 'position.save' }), formatMessage({ id: 'position.save.success' }));
      })
      .catch(response => errorNotification(formatMessage({ id: 'position.save' }), getResponseError(response)));
  };

  React.useEffect(() => {
    const subscription = watch((_, f) => {
      if (!f || !f.name) {
        return;
      }
      if (f.name !== 'pan' && f.name !== 'tilt' && f.name !== 'zoom') {
        return;
      }
      handleSave();
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  if (!camera) return null;
  const handleInc = name => {
    let value = round(Number(getValues(name)) + 0.01);
    if (value > 1) {
      value = 1;
    }
    setValue(name, value);
  };
  const handleDec = name => {
    const min = name === 'zoom' ? 0 : -1;
    let value = round(Number(getValues(name)) - 0.01);
    if (value < min) {
      value = min;
    }
    setValue(name, value);
  };
  return (
    <>
      <div className="camera-inputs">
        <form>
          <TextInputWithLabel type="text" inputProps={{ ...register('name') }} label={formatMessage({ id: 'position.name' })} variant="material" />
          <TextInputWithLabel type="number" inputProps={{ ...register('tilt', onlyNumbersOption), max: 1, min: -1 }} label={formatMessage({ id: 'camera.tilt' })} variant="material" />
          <TextInputWithLabel type="number" inputProps={{ ...register('pan', { valueAsNumber: true }), max: 1, min: -1 }} label={formatMessage({ id: 'camera.pan' })} variant="material" />
          <TextInputWithLabel type="number" inputProps={{ ...register('zoom', { valueAsNumber: true }), max: 1, min: 0 }} label={formatMessage({ id: 'camera.zoom' })} variant="material" />
        </form>
      </div>
      <div className="camera-position-controls">
        <div className="camera-position">
          <div className="position-button up-button" onClick={() => { handleInc('tilt'); }}><Icons customIcon icon="play-2" /></div>
          <div className="position-button right-button" onClick={() => { handleInc('pan'); }}><Icons customIcon icon="play-2" /></div>
          <div className="position-button bottom-button" onClick={() => { handleDec('tilt'); }}><Icons customIcon icon="play-2" /></div>
          <div className="position-button left-button" onClick={() => { handleDec('pan'); }}><Icons customIcon icon="play-2" /></div>
        </div>
        <div className="camera-zoom">
          <div className="zoom-button" onClick={() => { handleInc('zoom'); }}><Icons customIcon icon="plus" /></div>
          <div className="zoom-button" onClick={() => { handleDec('zoom'); }}><Icons customIcon icon="minus" /></div>
        </div>
      </div>
      {
        editZone ? (
          <div className="camera-polygon">
            <Icons customIcon icon="polygon" />
          </div>
        ) : null
      }
      <div className="zone-edit-buttons">
        <Button variant="secondary" onClick={handleSavePosition}><Icons customIcon width={22} height={22} icon="folder-minus" />{formatMessage({ id: 'camera.position.save' })}</Button>
      </div>
    </>

  );
}
